import { render } from "./CustomerWidgetOrders.vue?vue&type=template&id=6071235b&scoped=true&ts=true"
import script from "./CustomerWidgetOrders.vue?vue&type=script&lang=ts"
export * from "./CustomerWidgetOrders.vue?vue&type=script&lang=ts"

import "./CustomerWidgetOrders.vue?vue&type=style&index=0&id=6071235b&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\caffeine\\caffeineshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6071235b"]])

export default __exports__